var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    {
      staticClass: "modal-deed-owner-holder-detail",
      attrs: {
        show: _vm.showModal,
        title: _vm.modalTitle,
        size: "large",
        needFooter: true,
        needHeader: true,
        centered: true,
        closeBtn: true,
        bodyClass: "pb-sm-0",
      },
      on: {
        close: function ($event) {
          return _vm.onCloseModal({ directAction: true })
        },
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c("div", { staticClass: "modal-footer border-0 p-2" }, [
                _c("div", { staticClass: "row w-100 m-0 no-gutters" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "div",
                      { staticClass: "row d-flex justify-content-center" },
                      _vm._l(_vm.activeButtons, function (btn) {
                        return _c(
                          "div",
                          {
                            key: `btn-${_vm.idPanel}-${btn.id}`,
                            staticClass: "col-12 col-lg-3 pb-2 pb-sm-0",
                            class: [
                              { "col-sm-6": _vm.activeButtons.length == 2 },
                              btn.divClass,
                            ],
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-rounded btn-md btn-responsive btn-block min-w-auto",
                                class: btn.class,
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return btn.fn.apply(null, arguments)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.$t(btn.name)) +
                                    "\n                            "
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ]),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("div", { staticClass: "row deed-owner-holder-panel" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _vm.showModal
              ? _c("DeedOwnerHolderForm", {
                  attrs: {
                    panelCfg: _vm.panel,
                    parentId: _vm.idPanel,
                    vScope: _vm.vScope,
                    additional: _vm.additional,
                    baseTranslateID: _vm.translateID,
                    readonlyForm: _vm.readonlyFormItem,
                    start_types: _vm.start_types,
                    end_types: _vm.end_types,
                    genders: _vm.genders,
                    religions: _vm.religions,
                    causes_death: _vm.causes_death,
                  },
                  model: {
                    value: _vm.form,
                    callback: function ($$v) {
                      _vm.form = $$v
                    },
                    expression: "form",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }